import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiShoppingCart } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';
import LoginModal from './LoginModal';
import logoMetalizado from '../../assets/images/logo-metalizado.png';
import './PortalHeader.scss';

const PortalHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const { getCartCount } = useCart();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const cartItemCount = getCartCount();

  const handleAuthButton = () => {
    if (isAuthenticated) {
      // Logout y mantener en el portal público
      logout();
      navigate('/portal');
    } else {
      // Abrir modal de login
      setShowLoginModal(true);
    }
  };

  return (
    <>
      <header className="portal-header">
        <div className="portal-header__container">
          <div className="portal-header__logo" onClick={() => navigate('/portal')}>
            <img src={logoMetalizado} alt="Betel Natural" />
          </div>

          <div className="portal-header__actions">
            {isAuthenticated && (
              <button
                className="portal-header__cart"
                onClick={() => navigate('/portal/crear-orden')}
                title="Ver carrito"
              >
                <FiShoppingCart />
                {cartItemCount > 0 && (
                  <span className="cart-badge">{cartItemCount}</span>
                )}
              </button>
            )}

            <button
              className="portal-header__logout"
              onClick={handleAuthButton}
            >
              {isAuthenticated ? 'CERRAR SESIÓN' : 'INICIAR SESIÓN'}
            </button>
          </div>
        </div>
      </header>

      <div className="portal-header__stripe"></div>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </>
  );
};

export default PortalHeader;
